module.exports = __webpack_public_path__ + "media/images/clouds-99681572f92932dd14b337a79fec0e79.png";